export {}

export const initProductVariant = () => {
  const productVariants = document.querySelectorAll<HTMLElement>(".i-product-variant")
  const mediaQuery = window.matchMedia("(min-width: 1499px)")

  productVariants.forEach((variant) => {
    const content = variant.querySelector<HTMLElement>(".i-product-variant__content")
    const container = variant.closest<HTMLElement>(".s-product-variants .container")
    const header = variant.querySelector(".i-product-variant__header")

    header?.addEventListener("click", () => {
      variant.classList.toggle("--open")
    })

    if (!container || !content) return

    let prevWidth: number

    const setWidth = (width: number, offset: number) => {
      content.style.setProperty("width", `${width - offset}px`)
    }

    new ResizeObserver((changes) => {
      for (const change of changes) {
        if (change.contentRect.width === prevWidth) return
        prevWidth = change.contentRect.width

        if (mediaQuery.matches) {
          setWidth(prevWidth, 16)
        } else {
          setWidth(prevWidth, 8)
        }
      }
    }).observe(container)
  })
}

initProductVariant()
